import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import ToggleField from '../../ToggleField/ToggleField';

import logo from '../../../assets/images/integrations/fiona.png';

const FionaFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="FionaFields">
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" />
                                { t('settings.integrations.fiona.title') }
                            </CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                    <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.fiona.name")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.fiona.name" id="name" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.fiona.edition_id")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.fiona.edition_id" id="edition_id" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.fiona.api_key")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.fiona.api_key" id="api_key" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>

                        <CardBody>
                            <CardTitle className="small">{ t('settings.integrations.fiona.import.title') }</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""}>{t("settings.integrations.fiona.import.screenings.title")}</Label>
                                            <Col lg={1} >
                                            <ToggleField name="integrations.fiona.import.screenings.enabled" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.fiona.import.screenings.delete_future")}</Label>
                                            <Col lg={1} >
                                            <ToggleField name="integrations.fiona.import.screenings.delete_future" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.fiona.import.screenings.delete_existing")}</Label>
                                            <Col lg={1} >
                                            <ToggleField name="integrations.fiona.import.screenings.delete_existing" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default FionaFields;
